import Tooltip from '@atlaskit/tooltip';
import { Link } from '@atlassian/amkt-common';
import React from 'react';
import { useWatchApp } from './useWatchApp';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TooltipContent = 'Watch this app and get email alerts for new version releases. You can stop watching this app at anytime';
const WatchApp = props => {
  const {
    watchingStatus,
    watcherCount,
    handleStopWatching,
    handleStartWatching
  } = useWatchApp(props);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      content: /*#__PURE__*/_jsx("span", {
        children: TooltipContent
      }),
      children: watchingStatus ? /*#__PURE__*/_jsxs(Link, {
        href: props.loginHref,
        onClick: handleStopWatching,
        children: ["Stop Watching (", watcherCount, ")"]
      }) : /*#__PURE__*/_jsxs(Link, {
        href: props.loginHref,
        onClick: handleStartWatching,
        children: ["Watch App (", watcherCount, ")"]
      })
    })
  });
};
export default WatchApp;